import {useEffect, useState} from 'preact/hooks';
import {checkConfigurations, combinedHealth} from '../../../../shared/configuration-health.js';
import {gqlFetch} from '../../../../shared/models/product-configurator';

export function ProblemsBadge({health, draftHealth}) {
  const hasProblems = [health, draftHealth].some(report => report?.status === 'error' || report?.issues?.length > 0);
  return hasProblems ? <s-badge tone="caution">Problems</s-badge> : null;
}

export default function ConfigurationHealth({product}) {
  const [reports, setReports] = useState(null);
  const fingerprint = JSON.stringify([product.publishedConfiguration, product.configuration]);
  useEffect(() => {
    let active = true;
    setReports(null);
    checkConfigurations(JSON.parse(fingerprint), gqlFetch).then(value => { if (active) setReports(value); })
      .catch(() => { if (active) setReports([{status: 'error', issues: []}, {status: 'error', issues: []}]); });
    return () => { active = false; };
  }, [fingerprint]);
  if (!reports) return null;
  const {issues, failedVersions} = combinedHealth(reports);
  if (!issues.length && !failedVersions.length) return null;
  return <s-banner tone="warning" heading={issues.length ? 'Product options need attention' : 'Could not check product options'}>
    {failedVersions.length > 0 && <s-paragraph>We couldn't check {failedVersions.length === 2 ? 'Draft and Published' : failedVersions[0]}. Reload this page and try again before publishing.</s-paragraph>}
    {issues.length > 0 && <>
      <s-paragraph>An item used by an option has been deleted. Edit the affected option to choose a replacement or remove it, then save and publish.</s-paragraph>
      <s-unordered-list>{issues.map(issue => <s-list-item key={issue.key}><s-text type="strong">{issue.affected}:</s-text> {issue.groupLabel} — {issue.choiceLabel}{issue.requiredBlocked ? issue.conditional ? '. Customers cannot complete this required option when it is shown.' : '. Customers cannot complete this required option.' : '. This choice is unavailable.'}</s-list-item>)}</s-unordered-list>
    </>}
  </s-banner>;
}
